import { ReactComponent as Check } from "../../assets/svgIcon/listView/check.svg";
import { useDispatch } from "react-redux";
import { setAlloctionType } from "../../../../store/slice/newInterfaceSlice";
import styled from "styled-components";
import { BlurModal } from "../components/BlurModal/BlurModal";
import { GeneralModal } from "../../components/GeneralModal/GeneralModal";

/**
 * SelectAllocation Component
 *
 * A modal dialog that allows users to choose between
 * purchase, transfer, sales, and manufacturing allocation views.
 * On selection, it triggers the parent state update and closes the modal.
 *
 * @component
 *
 * @param {Function} closeModal - Function to close the dialog.
 * @param {"purchase" | "transfer" | "salesOrder" | "manufacturingOrder"} selectedOption - Currently selected allocation type.
 * @param {Function} setAllocation - Callback to update the selected allocation type.
 *
 */

const ALLOCATION_OPTIONS = [
  { id: "purchase", label: "Purchase" },
  { id: "transfer", label: "Transfer" },
  { id: "salesOrder", label: "Sales" },
  { id: "manufacturingOrder", label: "Manufacturing" },
];

const SelectAllocation = ({ closeModal, selectedOption, setAllocation }) => {
  const dispatch = useDispatch();
  const handleSelect = item => {
    setAllocation(item);
    dispatch(setAlloctionType(item));
    closeModal();
  };

  return (
    <BlurModal>
      <GeneralModal titleOfModal="Allocation" closeModal={closeModal} widthOfGeneralModal="30vw">
        <AllocationOptionsCss>
          {ALLOCATION_OPTIONS.map(({ id, label }) => (
            <OptionRow
              key={id}
              type="button"
              className={selectedOption === id ? "activeItem" : ""}
              onClick={() => handleSelect(id)}
            >
              {label}
              {selectedOption === id && <Check />}
            </OptionRow>
          ))}
        </AllocationOptionsCss>
      </GeneralModal>
    </BlurModal>
  );
};

const allocationDataByType = {
  purchase: {
    title: "Purchase",
    moduleName: "po_allocation",
    exportConstant: "shipment_po",
  },
  transfer: {
    title: "Transfer",
    moduleName: "tf_ord_allocation",
    exportConstant: "shipment_to",
  },
  salesOrder: {
    title: "Sales",
    moduleName: "so_allocation",
    exportConstant: "allocation_so",
  },
  manufacturingOrder: {
    title: "Manufacturing",
    moduleName: "mo_allocation",
    exportConstant: "allocation_mo",
  },
};

export { SelectAllocation, allocationDataByType };

const AllocationOptionsCss = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const OptionRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--DARK-GREY, #0e0e2c);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  cursor: pointer;

  &:hover {
    color: #1249bf;
    background: var(--MIST, #f7f8f9);
  }

  &.activeItem {
    font-weight: 500;
  }
`;
